/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { WhatsNewConfigModel } from '../../models/whats-new-config-model';

export interface GetWhatsNewConfig$Params {
}

export function getWhatsNewConfig(http: HttpClient, rootUrl: string, params?: GetWhatsNewConfig$Params, context?: HttpContext): Observable<StrictHttpResponse<WhatsNewConfigModel>> {
  const rb = new RequestBuilder(rootUrl, getWhatsNewConfig.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<WhatsNewConfigModel>;
    })
  );
}

/**
 * Custom addition for our mocking infrastructure
 * in case this ever causes problems we can also keep a dictionary that maps operations to paths on the side
 **/
getWhatsNewConfig.PATH = '/api/featuredetails/getwhatsnewconfig';
getWhatsNewConfig.METHOD = 'get';

/**
 * we annotate each endpoint with a root rootUrl
 * this is because we have multiple APIs so we need to know which api fn belongs to
 * so we can map it depending on the env. rootUrl is picked from the first server listed in the APISpec
 **/
getWhatsNewConfig.ROOTURL = '/portal';
